const AddGuidelineActionName = 'AddNewGuideline'
const AmmoniaLookupTable = 'ammonialookuptable'
const LookupTable = 'lookuptable'
export {
  AddGuidelineActionName,
  AmmoniaLookupTable,
  LookupTable,
}